(() => {
    let announcements = document.querySelectorAll('.shopify-section--announcement-bar');
    let mainHeader = document.getElementsByClassName('shopify-section--header');
    let generalAnnouncement = document.getElementsByClassName('announcement-bar-general');
    let announcementNavbar = document.getElementsByClassName('shopify-section--announcement-userbar-enchliving');
    let totalHeight = 0;
    let sizes = [];
    var window_width = null;

    widthActual();
    getHeights();

    function getHeights() {
        if (announcements.length > 1) {
            for (let i = 0; i < announcements.length; i++) {
                const announcement = announcements[i];
                let announcementHeight = announcement.getBoundingClientRect().height;
                sizes.push(announcementHeight);
                let topDistance = announcementHeight;
            }

            const totalHeight = sizes.reduce((accumulator, actualValue) => accumulator + actualValue, 0);
            mainHeader[0].style.setProperty('--announcement-total-bars-height', `${totalHeight.toFixed(2)}px`);

            if (generalAnnouncement.length != 0) {
                let generalAnnouncementHeight = generalAnnouncement[0].getBoundingClientRect().height;
                announcementNavbar[0].style.setProperty('--announcement-navbar-height', `${generalAnnouncementHeight}px`);
            }

        } else {
            if (generalAnnouncement.length == 0) {
                let announcementNavbarHeight = '';
                
                if(announcementNavbar[0]) {
                    announcementNavbarHeight = announcementNavbar[0].getBoundingClientRect().height;
                    mainHeader[0].style.setProperty('--announcement-total-bars-height', `${announcementNavbarHeight.toFixed(2)}px`);
                    announcementNavbar[0].style.setProperty('top', `${0}px`);
                }

            } else {
                let generalAnnouncementHeight = generalAnnouncement[0].getBoundingClientRect().height;
                mainHeader[0].style.setProperty('--announcement-total-bars-height', `${generalAnnouncementHeight.toFixed(2)}px`);
            }
        }
    }

    function widthActual() {
        window_width = window.innerWidth;
    }

    document.addEventListener("DOMContentLoaded", (ev) => {
        window.addEventListener("resize", (event) => {
            widthActual();
            sizes = [];
            getHeights();
        });
    });
})()